import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { FONT, SPACING, COLORS, MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import { COLORS_BACKGROUND } from '@zola/zola-ui/src/styles/emotion/colors';

export enum ComponentSize {
  DEFAULT = 'default',
  SMALL = 'small',
}

export const IllustrationContainer = styled.figure`
  align-items: end;
  background: ${COLORS_BACKGROUND.LIGHT_GRAY};
  display: flex !important;
  min-height: 150px;
  overflow: hidden;
  width: 100%;

  ${MEDIA_QUERY.MOBILE} {
    min-height: 112px;
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    max-height: 220px;
  }
`;

export const Illustration = styled.img`
  width: 100%;
`;

export const Content = styled.div`
  padding: ${SPACING.S16} ${SPACING.S16} ${SPACING.LG};
  text-align: center;
`;
// * !important is needed when the component is embedded in a zola-ui one
export const Title = styled.h3`
  color: ${COLORS.LILAC_2} !important;
  font-family: ${FONT.FONT_FAMILY_NEW_SPIRIT} !important;
  font-size: ${FONT.SIZE.LARGER} !important;
  font-weight: ${FONT.WEIGHT.MEDIUM} !important;
  line-height: ${SPACING.LG} !important;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    font-size: ${FONT.SIZE.LARGE} !important;
    line-height: ${SPACING.S32} !important;
  }
`;

// * !important is needed when the component is embedded in a zola-ui one
export const Text = styled.p`
  color: ${COLORS.LILAC_2} !important;
  font-family: ${FONT.FONT_FAMILY_CIRCULAR} !important;
  font-size: ${FONT.SIZE.SMALL} !important;
  font-weight: ${FONT.WEIGHT.REGULAR} !important;
  line-height: ${SPACING.S24} !important;
  margin: ${SPACING.SM} 0 0 !important;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    font-size: ${FONT.SIZE.SMALLER} !important;
    line-height: ${SPACING.MD} !important;
  }
`;

export const StyledCTA = styled(ButtonV3)`
  margin: ${SPACING.S16} auto;
`;

export const Container = styled.div<{ size?: ComponentSize }>`
  align-items: center;
  background: ${COLORS_BACKGROUND.MAUVE};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  width: 100%;

  ${({ size }) =>
    size === ComponentSize.SMALL &&
    `
    max-height: 378px;
    max-width: 274px;

    ${Title} {
      font-size: ${FONT.SIZE.REGULAR} !important;
      line-height: ${SPACING.S24} !important;
    }

    ${Content} {
      padding: ${SPACING.S16};
    }

    ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
      max-height: 356px;
      max-width: 195px;

      ${Text} {
        font-size: ${FONT.SIZE.EXTRA_SMALL} !important;
        line-height: ${SPACING.S16} !important;
      }
    }

    ${MEDIA_QUERY.MOBILE} {
      max-height: 324px;

      ${Text} {
        margin: ${SPACING.XS} 0 0 !important;
      }

      ${StyledCTA} {
        margin: ${SPACING.XS} auto;
      }

      ${Content} {
        padding: ${SPACING.XS};
      }
    }
  `}
`;
